import { Grid } from '@material-ui/core';
import React from 'react';
import PlaceholderImage from '../../components/placeholder-image';
import Section from '../../components/section';

type FeatureBlockProps = {
  image?: React.ReactNode;
  flipped?: boolean;
};

const FeatureBlock: React.FC<FeatureBlockProps> = props => (
  <Section>
    <Grid container spacing={4} justifyContent="space-between" alignItems="center">
      {!props.flipped ? (
        <Grid item md={6} xs={12}>
          {props.children}
        </Grid>
      ) : (
        ''
      )}
      <Grid item md={6} xs={12} style={{ textAlign: 'center' }}>
        {props.image || <PlaceholderImage />}
      </Grid>
      {props.flipped && (
        <Grid item md={6} xs={12}>
          {props.children}
        </Grid>
      )}
    </Grid>
  </Section>
);

export default FeatureBlock;
